export default __webpack_public_path__ + "static/real_time-66af2e17dd687b9cde60bbe7034cbb08.png";